var map = {
	".": "V/PH",
	"./": "V/PH",
	"./01_error_code": "Py8D",
	"./01_error_code.json": "Py8D",
	"./02_timestamp": "Ui1f",
	"./02_timestamp.json": "Ui1f",
	"./03_digital_rule": "OGaA",
	"./03_digital_rule.json": "OGaA",
	"./04_rate_limits": "dz5L",
	"./04_rate_limits.json": "dz5L",
	"./05_system_time": "TbUJ",
	"./05_system_time.json": "TbUJ",
	"./index": "V/PH",
	"./index.js": "V/PH",
	"./index_share_to_v1": "qxfP",
	"./index_share_to_v1.js": "qxfP"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Mz5m";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/cswap/api/basic ^.*$
// module id = Mz5m
// module chunks = 3